import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    GetReportData
};

async function GetReportData(data) {
    
    var model = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        date: data.date
    };

    const response = await CommonPost('/api/VarianceReport/GetVarianceReportData', null, model);
    return response.data;

}